import axios from 'axios'
import { APP_CONFIG } from '@/core/config/app.config'
import { LocalStorageService } from '../storage/local-storage.service'
import { ElMessage } from 'element-plus'
import router from '@/router'

const axiosInstance = axios.create({
  baseURL: APP_CONFIG.api.baseURL,
  timeout: APP_CONFIG.api.timeout,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
})

const storage = new LocalStorageService()

axiosInstance.interceptors.request.use(
  (config) => {
    const tokens = storage.getTokens()
    if (tokens.accessToken) {
      config.headers.Authorization = `Bearer ${tokens.accessToken}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (!error.response) {
      ElMessage.error('Network error. Please check your connection.')
      return Promise.reject(error)
    }

    const { status, data } = error.response

    switch (status) {
      case 401:
        storage.clearAuth()
        router.push({ name: 'login' })
        ElMessage.error('Session expired. Please login again.')
        break
      case 403:
        ElMessage.error(data?.message || 'You do not have permission to perform this action.')
        break
      case 404:
        ElMessage.error(data?.message || 'Resource not found.')
        break
      case 422:
        ElMessage.error(data?.message || 'Validation error.')
        break
      case 500:
        ElMessage.error('Server error. Please try again later.')
        break
      default:
        ElMessage.error(data?.message || 'An error occurred.')
    }

    return Promise.reject(error)
  }
)

export default axiosInstance
